// hooks/useDebouncedSearch.js
import { useEffect, useState } from 'react';

export const useDebouncedSearch = (query, fetchFn, delay = 500) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!query) {
      setResults([]);
      return;
    }

    const handler = setTimeout(async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchFn(query);
        setResults(data);
      } catch (err) {
        setError('Something went wrong');
      } finally {
        setLoading(false);
      }
    }, delay);

    return () => clearTimeout(handler);
  }, [query, fetchFn, delay]);

  return { results, loading, error };
};
